// extracted by mini-css-extract-plugin
export default {"section-11":"styles_section-11__iv7ni","logo-slideshow":"styles_logo-slideshow__tWwNm","partner-logos":"styles_partner-logos__Kmtf-","moveSlideshow":"styles_moveSlideshow__YD44j"};